import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { DuplicateAttendanceReportSchemaObject } from "../DuplicateAttendanceReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import "../../../Common/Table/table.css";
import xlsx from "json-as-xlsx";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import _ from "lodash";
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import { InputAdornment, Box } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import MessageModal from '../../../../UI/Modal/MessageModal';

const screenCode = "DUPLICATEATTENDANCEREPORT";

export function DuplicateAttendanceReport(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [reportDetails, setReportDetails] = useState({
    groupID: "0",
    jobType: "0",
    estateID: "0",
    divisionID: "0",
    date: new Date().toISOString().split('T')[0]
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "",
    jobTypeName: "",
    estateName: "",
    divisionName: "",
    date: ""
  });

  const [errors, setErrors] = useState({});

  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [data, setData] = useState([]);
  const [reportData, setReportData] = useState([]);

  const jobTypes = {
    "0": "All Job Types",
    "1": "General",
    "2": "Cash"
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const schema = Joi.object(DuplicateAttendanceReportSchemaObject).options({
    allowUnknown: true,
  });

  const [customSearch, setCustomSearch] = useState({
    searchText: ''
  });
  const [filteredData, setFilteredData] = useState([]);

  const [csvHeaders] = useState([
    { label: "Date", value: "date" },
    { label: "Reg No", value: "registrationNumber" },
    { label: "Employee Name", value: "employeeName" },
    { label: "Work Division", value: "workDivision" },
    { label: "Job", value: "job" },
    { label: "Job Type", value: "jobType" },
    { label: "Quantity", value: "quantity" },
    { label: "Man Day", value: "manDay" }
  ]);

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: ""
  });

  useEffect(() => {
    trackPromise(getPermissions(), getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [reportDetails.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
  }, [reportDetails.estateID]);

  useEffect(() => { }, [reportData]);

  useEffect(() => {
    if (data.length > 0) {
      handleCustomSearch(customSearch.searchText);
    }
  }, [customSearch.searchText]);

  function handleGroupChange(target) {
    validateInputs(target);
    setReportData([]);
    setData([]);
    setReportDetails({
      ...reportDetails,
      groupID: target.value,
      jobType: "0",
      estateID: "0",
      divisionID: "0",
      date: new Date().toISOString().split('T')[0]
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);
    setReportData([]);
    setData([]);
    setReportDetails({
      ...reportDetails,
      estateID: target.value,
      jobType: "0",
      divisionID: "0",
      date: new Date().toISOString().split('T')[0]
    });
  }
  function handleJobTypeChange(target) {
    validateInputs(target);
    setReportData([]);
    setData([]);
    setReportDetails({
      ...reportDetails,
      jobType: target.value,
      divisionID: "0",
      date: new Date().toISOString().split('T')[0]
    });
  }

  function handleDivisionChange(target) {
    validateInputs(target);
    setReportData([]);
    setData([]);
    setReportDetails({
      ...reportDetails,
      divisionID: target.value,
      date: new Date().toISOString().split('T')[0]
    });
  }

  function handleDateChange(target) {
    validateInputs(target);
    setReportData([]);
    setData([]);
    setReportDetails({
      ...reportDetails,
      date: target.value,
    });
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      DuplicateAttendanceReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWDUPLICATEATTENDANCEREPORT"
    );

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );

    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromTokenV2();

    if (token.operationEntities.length > 0) {
      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }
      setMultipleEstates(estateArray)
      setReportDetails({
        ...reportDetails,
        groupID: token.groupID
      });
    } else {
      setReportDetails({
        ...reportDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID,
      });
    }

    setReportDetails({
      ...reportDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID,
    });
    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(reportDetails.groupID);
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(reportDetails.estateID);
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch(e) {
    e.preventDefault();

    const errorMessages = validate(schema, reportDetails);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    getSelectedDropdownValuesForReport(reportDetails);
    var reportData = await services.getDuplicateAttendanceReportData(reportDetails);

    if (reportData && reportData.length > 0) {
      var formattedData = reportData.map(record => ({
        ...record,
        date: moment(record.date).format("YYYY-MM-DD")
      }));
      setPage(0);
      setReportData(reportData);
      setData(formattedData);
      setFilteredData(formattedData);
      setCustomSearch({ searchText: '' });
    } else {
      setReportData([]);
      setData([]);
      setFilteredData([]);
      setCustomSearch({ searchText: '' });

      setMessageModel({
        hidden: false,
        type: "Warning",
        disciption: "No records found for the selected criteria"
      });

      setTimeout(() => {
        setMessageModel((prevModel) => ({
          ...prevModel,
          hidden: true
        }));
      }, 4000);
    }
  }

  function createFile() {
    var settings = {
      sheetName: "Duplicate Attendance Report",
      fileName: "Duplicate Attendance Report",
      writeOptions: {},
    };

    var copyOfCsv = _.cloneDeep(data);

    var newRow1 = {
      date: "Group: " + groups[reportDetails.groupID],
      registrationNumber: "Operation Entity: " + multipleEstates[reportDetails.estateID],
      employeeName: "Collection Point: " + (reportDetails.divisionID !== "0" ? divisions[reportDetails.divisionID] : "All Divisions")
    }
    var newRow2 = {
      date: "Date: " + reportDetails.date,
      registrationNumber: "",
      employeeName: ""
    }

    copyOfCsv.push({}, newRow1, newRow2);
    xlsx(csvHeaders, copyOfCsv, settings, true);
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setReportDetails({
      ...reportDetails,
      jobType: "0",
      divisionID: "0",
      date: new Date().toISOString().split('T')[0]
    });
    setData([]);
    setReportData([]);
    setFilteredData([]);
    setCustomSearch({ searchText: '' });
    setErrors({});
    setPage(0);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groups[searchForm.groupID],
      estateName: multipleEstates[searchForm.estateID],
      divisionName: searchForm.divisionID !== "0" ? divisions[searchForm.divisionID] : "All Divisions",
      date: searchForm.date
    });
  }

  function handleCustomSearch(searchValue) {
    if (!searchValue || searchValue === '') {
      setFilteredData(data);
    } else {
      const filtered = data.filter(row => {
        return (
          row.registrationNumber?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.employeeName?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.workDivision?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.job?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.jobType?.toLowerCase().includes(searchValue.toLowerCase()) ||
          row.date?.includes(searchValue)
        );
      });
      setFilteredData(filtered);
    }
  }

  function handleCustomSearchChange(e) {
    setCustomSearch({
      ...customSearch,
      searchText: e.target.value
    });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Duplicate Attendance Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-3">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={reportDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={reportDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(multipleEstates)}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText error>
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="jobType">
                      Job Type
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="jobType"
                      id="jobType"
                      name="jobType"
                      value={reportDetails.jobType}
                      onChange={(e) => handleJobTypeChange(e.target)}
                    >
                      {generateDropDownMenu(jobTypes)}
                    </Select>
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="divisionID">
                      Collection Point
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={reportDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--All Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                  </div>
                  <div className="col-md-3">
                    <InputLabel shrink id="date">
                      Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="date"
                      name="date"
                      type="date"
                      value={reportDetails.date}
                      onChange={(e) => handleDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["date"] && (
                      <FormHelperText error>
                        {errors["date"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, reportDetails)}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(handleSearch(e))}
                  />
                  <input
                    type="reset"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>
              {data.length !== 0 ? (
                <div>
                  <Box display="flex" flexDirection="row-reverse" p={2}>
                    <TextField
                      size="small"
                      style={{ width: '300px' }}
                      placeholder="Search"
                      onChange={(e) => handleCustomSearchChange(e)}
                      value={customSearch.searchText}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <div className="row">
                    <div className="col-md-12">
                      <div>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Date</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Reg No</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Work Division</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Job</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Job Type</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Quantity</TableCell>
                                  <TableCell align="center" style={{ fontWeight: "bold" }}>Man Day</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredData.slice(page * limit, page * limit + limit).map((row, i) => (
                                  <TableRow key={i} >
                                    <TableCell align="center" >{row.date}</TableCell>
                                    <TableCell align="center" >{row.registrationNumber}</TableCell>
                                    <TableCell align="center" >{row.employeeName}</TableCell>
                                    <TableCell align="center" >{row.workDivision}</TableCell>
                                    <TableCell align="center" >{row.job}</TableCell>
                                    <TableCell align="center" >{row.jobType}</TableCell>
                                    <TableCell align="right" >{parseFloat(row.quantity).toFixed(2)}</TableCell>
                                    <TableCell align="center" >{row.manDay}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={filteredData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25, 50]}
                            />
                          </TableContainer>
                        </Box>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {data.length !== 0 ? (
              <div className="pt-2 pb-2">
                <ReactToPrint
                  documentTitle={"Duplicate Attendance Report"}
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={data}
                    searchData={selectedSearchValues}
                  />
                </div>
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-2"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}